const DRAFT_KEY = "dhj_beta_draft";
const TESTERS_KEY = "dhj_beta_testers";

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getBetaDraft() {
  return readJson(DRAFT_KEY, {});
}

export function saveBetaDraft(patch) {
  const next = { ...getBetaDraft(), ...patch };
  writeJson(DRAFT_KEY, next);
  return next;
}

export function recordAcceptance() {
  const acceptedAt = new Date().toISOString();
  return saveBetaDraft({ acceptedAt, betaAccepted: true });
}

export function listJourneyTesters() {
  return readJson(TESTERS_KEY, []);
}

export function storeJourneyTester(profile) {
  const testers = listJourneyTesters();
  const email = String(profile.email || "").toLowerCase();
  const record = {
    ...profile,
    email,
    betaTester: true,
    betaAccepted: true,
    storedAt: new Date().toISOString(),
  };
  const index = testers.findIndex((row) => row.email === email);
  if (index === -1) testers.push(record);
  else testers[index] = { ...testers[index], ...record };
  writeJson(TESTERS_KEY, testers);
  saveBetaDraft({
    ...record,
    completedAt: record.storedAt,
  });
  return record;
}
